// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".paper-share-page-wrapper .search-input .el-input-group__append{background-color:#df5813;border-color:#df5813;color:#fff;cursor:pointer}", ""]);
// Exports
module.exports = exports;
